import { useState } from 'react';

import IQLogoGlowAnimated from 'assets/IQLogos/IQAnimatedLogo/IQLogoAnimated';
import cx from 'classnames';
import { AnimatePresence } from 'framer-motion';

import IQMenuContainer from 'lib/common/contexts/AIContext/components/IQMenuContainer/IQMenuContainer';

import { useAIContext } from '../../Context';
import { StreamingText } from '../IQCritique/components/StreamingText/StreamingText';
import SlideInEffect from '../common/SlideInEffect/SlideInEffect';
import { TIQDisplayMode } from '../constants/IQDisplayMode';
import { IQResponseState } from '../constants/IQResponseState';
import { IQGreetings } from './const/IQGreetings';

import styles from './iq-stand-alone.module.scss';

// Select a random greeting
const getRandomGreeting = () => {
  return IQGreetings[Math.floor(Math.random() * IQGreetings.length)];
};

export default function IQStandAlone({ displayMode }: { displayMode: TIQDisplayMode }) {
  const {
    state: { selectedAction, response, requestState },
  } = useAIContext();

  const [isHeadingComplete, setIsHeadingComplete] = useState(false);
  const [isSubHeadingComplete, setIsSubHeadingComplete] = useState(false);
  const [IQGreeting] = useState(getRandomGreeting());

  const showIQResponse =
    requestState === IQResponseState.ERROR ||
    requestState === IQResponseState.THINKING ||
    requestState === IQResponseState.RETHINKING ||
    (Boolean(response) && Boolean(selectedAction));

  const renderIQMenuContent = () => {
    if (showIQResponse) {
      return null;
    }

    return (
      <>
        <div className={styles['iq-stand-alone__heading']}>
          <AnimatePresence exitBeforeEnter>
            {!selectedAction ? (
              <SlideInEffect key="heading1" direction="right" disableInitialAnimation={!isHeadingComplete}>
                <div className={styles['iq-stand-alone__heading__text-container']}>
                  <StreamingText
                    disableAnimation={isHeadingComplete}
                    fontType="heading1"
                    textClassName={styles['iq-stand-alone__heading__text']}
                    speed={10}
                    text={IQGreeting}
                    onComplete={() => setIsHeadingComplete(true)}
                  />
                </div>
              </SlideInEffect>
            ) : (
              <SlideInEffect key="heading2" direction="left" disableInitialAnimation={!isSubHeadingComplete}>
                <div className={styles['iq-stand-alone__heading__text-container-2']}>
                  <StreamingText
                    disableAnimation={isSubHeadingComplete}
                    fontType="heading2"
                    textClassName={styles['iq-stand-alone__heading__text-2']}
                    speed={10}
                    text="I can tailor feedback to different styles — which do you prefer?"
                    onComplete={() => setIsSubHeadingComplete(true)}
                  />
                </div>
              </SlideInEffect>
            )}
          </AnimatePresence>
        </div>
      </>
    );
  };

  return (
    <div
      className={cx(styles['iq-stand-alone'], {
        [styles['iq-stand-alone--minimized']]: selectedAction,
      })}
    >
      <div className={styles['iq-stand-alone__content']}>
        {!selectedAction && (
          <div className={styles['iq-stand-alone__logo']}>
            <div className={styles['iq-stand-alone__logo__container']}>
              <div className={styles['iq-stand-alone__logo__image']} data-testid="iq-logo">
                <IQLogoGlowAnimated aria-label="IQ Logo" />
              </div>
            </div>
          </div>
        )}
        {!showIQResponse && renderIQMenuContent()}
        {isHeadingComplete && (
          <SlideInEffect direction="right" overrideStyles={{ width: '100%', justifyContent: 'center' }}>
            <div className={styles['iq-stand-alone__menu-container']}>
              <IQMenuContainer displayMode={displayMode} showAcceptForRewrites={false} />
            </div>
          </SlideInEffect>
        )}
      </div>
    </div>
  );
}
